import React from 'react';
import {
    Container,
    Grid,
    Typography,
    makeStyles
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import PriceListTable from './PriceListTable';

const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export default function PriceListListView() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Page
            className={classes.root}
            title={t('navbar.pricelists')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('navbar.pricelists')}
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <PriceListTable/>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}